import { useEffect, useRef } from "react";

import ringingSound from "./../../../assets/music/ringingSound.mp3";

export default function RingingSounds({ play }: { play: boolean }) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (play) {
      audioRef.current?.play();
    } else {
      audioRef.current?.pause();
      if (audioRef.current) audioRef.current.currentTime = 0;
    }
  }, [play]);

  return (
    <audio
      ref={audioRef}
      src={ringingSound}
      loop
    />
  );
}